import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { useStyles } from "./CircularProgress.style";

interface ICircularProgressProps {
  size?: number;
  enableAnimation?: boolean;
  borderLight?: boolean;
}

export const CircularProgress: FC<
  ICircularProgressProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const {
    className,
    style,
    size,
    enableAnimation,
    borderLight,
    ...othersProps
  } = props;
  const sizeApply = size || 30;

  const styleInternal = {
    width: sizeApply,
    height: sizeApply,
    border: `${sizeApply / 10}px solid transparent`,
    borderTopWidth: sizeApply / 10,
  };

  return (
    <div
      {...othersProps}
      className={clsx(
        borderLight ? classes.borderLight : classes.borderDark,
        classes.root,
        enableAnimation && classes.showAnimation,
        className,
      )}
      style={{ ...styleInternal, ...style }}
    />
  );
};
